// @src imports
import { Store } from 'src/redux/store'
// mutations
import fetchRetry from 'fetch-retry'
import { Set } from 'immutable'
import { saveAs } from 'file-saver'
import moment from 'moment'
import LogRocket from 'src/logrocket/logrocket'
import { CreateContactInput } from 'src/graphql/generated/graphql'

const fetch = fetchRetry(window.fetch, {
  retries: 3,
  retryOn: (attempt: number, error: Error | null, response: Response | null) =>
    error?.message === 'Failed to fetch' || response?.status === 503,
  retryDelay: (attempt: number) =>
    Math.pow(2, attempt) * (400 + Math.random() * 400), // ~600, ~1200, ~2400}
})

export const baseURL = process.env.REACT_APP_API_URL || ''

export const LEGACY_SITE_URL =
  process.env.REACT_APP_OLD_WEBSITE_URL || 'https://www.sendoutcards.com'

const getHeaders = (isFormData: boolean = false) => {
  const token = Store.getState().user.controlData.token
  const sessionURL =
    process.env.NODE_ENV === 'production' && LogRocket.sessionURL
  return {
    // eslint-disable-next-line no-useless-computed-key
    ...(isFormData ? {} : { ['Content-Type']: 'application/json' }),
    ...(token ? { Authorization: `Token ${token}` } : {}),
    ...(sessionURL ? { 'X-LogRocket-URL': sessionURL } : {}),
  }
}

export const createContactInput = (
  contact: Omit<CreateContactInput, 'companyName'> & {
    company?: string | null
  },
): CreateContactInput => {
  const { company, ...new_contact } = contact
  return {
    ...new_contact,
    companyName: company,
  }
}

export const exportContactsCsvFrom = async (
  source: 'contacts' | 'groups',
  uuids: Set<string>,
) => {
  const body = new FormData()
  body.append(source, uuids.toArray().join())

  const response = await fetch(`${baseURL}/contact/export/csv/`, {
    method: 'POST',
    headers: getHeaders(true),
    body,
  })

  const data = await response.blob()
  saveAs(data, `contacts-${moment().format('YYYY-MM-DD')}.csv`)
}
